{
  "Image upload": "Image upload",
  "Image": "Image",
  "Image preview": "Preview",
  "file-upload": "File upload",
  "help-image": "Only .png and .jpg — <0>(Maximum file size 4 MB and minimum dimensions 1280x720)</0>",
  "help-resource": "<0>Maximum file size 200 MB</0>",
  "help-audio": "Only .mp3 — <0>(Maximum file size 200 MB)</0>",
  "help-e-learning": "Only HTML5 e-learning ZIP — <0>(Maximum file size 1 GB)</0>",
  "Select file": "Select file",
  "file-too-large": "The file is too large.",
  "image-upload-space": "You need to select a space first.",
  "image-dimension-validation-fail": "The image doesn't follow the required dimensions (minimum dimensions 1280x720)",
  "File preview": "Preview",
  "image-upload-success": "Upload successful",
  "image-upload-success_discussion": "Upload successful. Save or update post to keep this image",
  "image-upload-success_admin": "Upload successful. Save to keep this image",
  "file-upload-success": "Upload successful. Save to keep this file",
  "Remove media": "Remove file",
  "PDF": "PDF",
  "Video": "Video link",
  "Cannot upload file - product does not belong to a space": "Cannot upload file. Product does not belong to a space",
  "Video preview": "Preview",
  "Embed external video": "Add",
  "URL": "Video link",
  "Video embed URL": "Insert video URL here",
  "upload-reset-space": "The image or file you uploaded was reset because space was changed",
  "image-size-limit-error": "Image is too large. Only .png and .jpg (Maximum size 4 MB)"
}
